import React from "react";

function MypageButton(props) {
    const { gotoMypage } = props;

    const handleClick = () => {
        gotoMypage();
    };
    return (
        <li className="fl display_btn4" onClick={handleClick}>
            <button type="button" className="my"></button>
        </li>
    );
}

export default MypageButton;
